import React from "react";
import TimeData from "../../components/employees/Time-data";

const UserTime = () => {
  return (
    <div className="commom-001">
      <TimeData />
    </div>
  );
};

export default UserTime;
